var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("compare_arrows"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.concurrent.title"))),
        ]),
        _c(
          "button",
          {
            staticClass: "add-btn",
            class: { active: _vm.showSearch },
            on: {
              click: function ($event) {
                _vm.showSearch = !_vm.showSearch
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(_vm._s(_vm.showSearch ? "close" : "add")),
            ]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dash.reporting.section.concurrent.add")) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm.showSearch
        ? _c("div", { staticClass: "search-panel" }, [
            _c("div", { staticClass: "search-input-wrap" }, [
              _c("i", { staticClass: "material-icons search-icon" }, [
                _vm._v("search"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                ],
                ref: "searchInput",
                staticClass: "search-input",
                attrs: { type: "text", placeholder: _vm.searchPlaceholder },
                domProps: { value: _vm.searchQuery },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.searchQuery = $event.target.value
                    },
                    _vm.onSearchInput,
                  ],
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "escape",
                        undefined,
                        $event.key,
                        undefined
                      )
                    )
                      return null
                    _vm.showSearch = false
                  },
                },
              }),
              _vm.searchLoading
                ? _c("div", { staticClass: "search-spinner" }, [
                    _c("div", { staticClass: "input-loader" }),
                  ])
                : _vm._e(),
            ]),
            !_vm.searchLoading && _vm.searchResults.length
              ? _c(
                  "div",
                  { staticClass: "search-results" },
                  _vm._l(_vm.searchResults, function (r, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "search-result",
                        on: {
                          click: function ($event) {
                            return _vm.selectResult(r)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "result-thumb" }, [
                          r.image
                            ? _c("img", { attrs: { src: r.image, alt: "" } })
                            : _c("i", { staticClass: "material-icons" }, [
                                _vm._v("account_circle"),
                              ]),
                        ]),
                        _c("div", { staticClass: "result-info" }, [
                          _c("div", { staticClass: "result-row1" }, [
                            _c("span", { staticClass: "result-name" }, [
                              _vm._v(_vm._s(r.name || r.unique_id)),
                            ]),
                            r.unique_id
                              ? _c("span", { staticClass: "result-handle" }, [
                                  _vm._v("@" + _vm._s(r.unique_id)),
                                ])
                              : _vm._e(),
                            r.id && !r.unique_id
                              ? _c("span", { staticClass: "result-handle" }, [
                                  _vm._v(_vm._s(r.id)),
                                ])
                              : _vm._e(),
                          ]),
                          r.description
                            ? _c("div", { staticClass: "result-desc" }, [
                                _vm._v(_vm._s(r.description)),
                              ])
                            : _vm._e(),
                        ]),
                        _c("i", { staticClass: "material-icons result-add" }, [
                          _vm._v("add_circle_outline"),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm.searchLoading
              ? _c(
                  "div",
                  { staticClass: "search-loading-results" },
                  _vm._l(3, function (i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "search-skeleton" },
                      [
                        _c("div", { staticClass: "skel-thumb" }),
                        _vm._m(0, true),
                      ]
                    )
                  }),
                  0
                )
              : _vm.searchQuery.length >= 2 && !_vm.searchLoading
              ? _c("div", { staticClass: "search-empty" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("dash.reporting.section.concurrent.no_results")
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.hasAnyConcurrent
        ? _c("div", { staticClass: "post-empty" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("group_add")]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("dash.reporting.section.concurrent.empty"))),
            ]),
          ])
        : [
            _vm.loading
              ? _c("div", { staticClass: "post-empty" }, [
                  _c("i", { staticClass: "material-icons spin" }, [
                    _vm._v("hourglass_empty"),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.reporting.section.concurrent.loading")
                      )
                    ),
                  ]),
                ])
              : _vm.error
              ? _c("div", { staticClass: "post-empty" }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      staticStyle: { color: "#e0d0ea" },
                    },
                    [_vm._v("error_outline")]
                  ),
                  _c("p", { staticStyle: { color: "#c0392b" } }, [
                    _vm._v(_vm._s(_vm.error)),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "page-btn",
                      staticStyle: { width: "auto", padding: "0 14px" },
                      on: { click: _vm.load },
                    },
                    [_vm._v(_vm._s(_vm.$t("dash.reporting.retry")))]
                  ),
                ])
              : _vm.allRows.length
              ? [
                  _c(
                    "div",
                    { staticClass: "concurrent-table" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "table-head",
                          style: { gridTemplateColumns: _vm.gridTemplate },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable",
                              class: _vm.sortClass("name"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("name")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.section.concurrent.page"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("name")))]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable align-right",
                              class: _vm.sortClass("followers"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("followers")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.section.concurrent.followers"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("followers")))]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable align-right",
                              class: _vm.sortClass("posts"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("posts")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.section.concurrent.posts"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("posts")))]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable align-right",
                              class: _vm.sortClass("reactions"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("reactions")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.pdf.listItem.reactions"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("reactions")))]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable align-right",
                              class: _vm.sortClass("comments"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("comments")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.pdf.listItem.comments"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("comments")))]
                              ),
                            ]
                          ),
                          _vm.network === "facebook"
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "col-header sortable align-right",
                                  class: _vm.sortClass("shares"),
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSort("shares")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.cap(
                                          _vm.$t(
                                            "dash.reporting.pdf.listItem.shares"
                                          )
                                        )
                                      )
                                  ),
                                  _c(
                                    "i",
                                    { staticClass: "material-icons sort-icon" },
                                    [_vm._v(_vm._s(_vm.sortIcon("shares")))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "span",
                            {
                              staticClass: "col-header sortable align-right",
                              class: _vm.sortClass("engagement"),
                              on: {
                                click: function ($event) {
                                  return _vm.onSort("engagement")
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.cap(
                                      _vm.$t(
                                        "dash.reporting.section.concurrent.engagement"
                                      )
                                    )
                                  )
                              ),
                              _c(
                                "i",
                                { staticClass: "material-icons sort-icon" },
                                [_vm._v(_vm._s(_vm.sortIcon("engagement")))]
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "col-header" }),
                        ]
                      ),
                      _vm._l(_vm.sortedRows, function (row) {
                        return _c(
                          "div",
                          { key: row.network_id, staticClass: "row-group" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "table-row",
                                class: {
                                  "row--own": row.isOwnPage,
                                  "row--pending": row.pending,
                                },
                                style: {
                                  gridTemplateColumns: _vm.gridTemplate,
                                },
                                on: {
                                  click: function ($event) {
                                    !row.pending &&
                                      !row.isOwnPage &&
                                      _vm.toggle(row.network_id)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "cell-page" }, [
                                  _c("div", { staticClass: "page-thumb" }, [
                                    row.concurrent_picture
                                      ? _c("img", {
                                          attrs: {
                                            src: row.concurrent_picture,
                                            alt: "",
                                          },
                                        })
                                      : _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("account_circle")]
                                        ),
                                  ]),
                                  _c("span", { staticClass: "page-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        row.concurrent_name || row.network_id
                                      )
                                    ),
                                  ]),
                                  row.pending
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "type-badge badge-pending",
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons spin",
                                              staticStyle: {
                                                "font-size": "10px",
                                                "margin-right": "2px",
                                              },
                                            },
                                            [_vm._v("hourglass_empty")]
                                          ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.reporting.section.concurrent.pending"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  !row.pending && !row.isOwnPage
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons expand-icon",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.expanded[row.network_id]
                                                  ? "expand_less"
                                                  : "expand_more"
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("span", { staticClass: "cell-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.pending
                                        ? "…"
                                        : _vm.fmt(_vm.rowFollowers(row))
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "cell-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.pending
                                        ? "…"
                                        : _vm.fmt(_vm.rowPostsCount(row))
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "cell-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.pending
                                        ? "…"
                                        : _vm.fmt(_vm.rowReactions(row))
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "cell-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.pending
                                        ? "…"
                                        : _vm.fmt(_vm.rowComments(row))
                                    )
                                  ),
                                ]),
                                _vm.network === "facebook"
                                  ? _c("span", { staticClass: "cell-num" }, [
                                      _vm._v(
                                        _vm._s(
                                          row.pending
                                            ? "…"
                                            : _vm.fmt(_vm.rowShares(row))
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("span", { staticClass: "cell-num" }, [
                                  _vm._v(
                                    _vm._s(
                                      row.pending ? "…" : _vm.rowEngagement(row)
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "cell-actions" }, [
                                  !row.isOwnPage
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "delete-btn",
                                          class: {
                                            loading:
                                              _vm.removeLoading[row.network_id],
                                          },
                                          attrs: {
                                            disabled:
                                              !!_vm.removeLoading[
                                                row.network_id
                                              ],
                                            title: _vm.$t(
                                              "dash.reporting.section.concurrent.remove"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.removeConcurrent(row)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.removeLoading[
                                                    row.network_id
                                                  ]
                                                    ? "hourglass_empty"
                                                    : "close"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            !row.isOwnPage && _vm.expanded[row.network_id]
                              ? _c(
                                  "div",
                                  { staticClass: "sub-section" },
                                  [
                                    _vm.rowPosts(row).length
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "post-head",
                                              style: {
                                                gridTemplateColumns:
                                                  _vm.postGridTemplate,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "col-header sortable",
                                                  class: _vm.postSortClass(
                                                    row.network_id,
                                                    "date"
                                                  ),
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPostSort(
                                                        row.network_id,
                                                        "date"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.cap(
                                                          _vm.$t(
                                                            "dash.reporting.pdf.listItem.date"
                                                          )
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons sort-icon",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.postSortIcon(
                                                            row.network_id,
                                                            "date"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "col-header" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cap(
                                                        _vm.$t(
                                                          "dash.reporting.pdf.listItem.publication"
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "col-header sortable align-right",
                                                  class: _vm.postSortClass(
                                                    row.network_id,
                                                    "reactions"
                                                  ),
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPostSort(
                                                        row.network_id,
                                                        "reactions"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.cap(
                                                          _vm.$t(
                                                            "dash.reporting.pdf.listItem.reactions"
                                                          )
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons sort-icon",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.postSortIcon(
                                                            row.network_id,
                                                            "reactions"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "col-header sortable align-right",
                                                  class: _vm.postSortClass(
                                                    row.network_id,
                                                    "comments"
                                                  ),
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPostSort(
                                                        row.network_id,
                                                        "comments"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.cap(
                                                          _vm.$t(
                                                            "dash.reporting.pdf.listItem.comments"
                                                          )
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons sort-icon",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.postSortIcon(
                                                            row.network_id,
                                                            "comments"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.network === "facebook"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "col-header sortable align-right",
                                                      class: _vm.postSortClass(
                                                        row.network_id,
                                                        "shares"
                                                      ),
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onPostSort(
                                                            row.network_id,
                                                            "shares"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.cap(
                                                              _vm.$t(
                                                                "dash.reporting.pdf.listItem.shares"
                                                              )
                                                            )
                                                          )
                                                      ),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons sort-icon",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.postSortIcon(
                                                                row.network_id,
                                                                "shares"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.paginatedPosts(row),
                                            function (p, i) {
                                              return _c(
                                                "div",
                                                {
                                                  key: i,
                                                  staticClass: "post-row",
                                                  style: {
                                                    gridTemplateColumns:
                                                      _vm.postGridTemplate,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "cell-date",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.postDate(p))
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "cell-post",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "post-msg",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.postMessage(p)
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.postLink(p)
                                                        ? _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "post-link",
                                                              attrs: {
                                                                href: _vm.postLink(
                                                                  p
                                                                ),
                                                                target:
                                                                  "_blank",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "i",
                                                                {
                                                                  staticClass:
                                                                    "material-icons",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "open_in_new"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "cell-num" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.fmt(
                                                            _vm.postReactions(p)
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "cell-num" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.fmt(
                                                            _vm.postComments(p)
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.network === "facebook"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "cell-num",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.fmt(
                                                                _vm.postShares(
                                                                  p
                                                                )
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm.postPageCount(row) > 1
                                            ? _c(
                                                "div",
                                                { staticClass: "pagination" },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "page-btn",
                                                      attrs: {
                                                        disabled:
                                                          _vm.getPage(
                                                            row.network_id
                                                          ) === 1,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.setPage(
                                                            row.network_id,
                                                            _vm.getPage(
                                                              row.network_id
                                                            ) - 1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("chevron_left")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "page-info",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getPage(
                                                            row.network_id
                                                          )
                                                        ) +
                                                          " / " +
                                                          _vm._s(
                                                            _vm.postPageCount(
                                                              row
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "page-btn",
                                                      attrs: {
                                                        disabled:
                                                          _vm.getPage(
                                                            row.network_id
                                                          ) ===
                                                          _vm.postPageCount(
                                                            row
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.setPage(
                                                            row.network_id,
                                                            _vm.getPage(
                                                              row.network_id
                                                            ) + 1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "chevron_right"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "post-empty",
                                            staticStyle: { padding: "20px 0" },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("inbox")]
                                            ),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.reporting.no_posts"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "skel-lines" }, [
      _c("div", { staticClass: "skel-line skel-line--wide" }),
      _c("div", { staticClass: "skel-line skel-line--narrow" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }